import React from 'react';

export default class Selected extends React.Component {

    constructor(props) {
      super(props);
      this.myScrollList = React.createRef();
	  this.state = {
        data : null
      };
    }
	
	componentDidMount () {
		this.$el = window.$(this.myScrollList.current);
		this.$el.mCustomScrollbar();
	}
	
	getCategories(){
		return this.props.cats.filter(cat => {
			let found = this.props.selected.find(shop => {
				if (shop.cats.indexOf(cat.id) !==-1 ) return true; 
				else return false;
			});
			if (found) return true; else return false;
		}).sort((a,b) => {
			if(a.title < b.title) { return -1; }
			if(a.title > b.title) { return 1; }
			return 0;
		});
	}
	
	getShops(cat_id) {
		return this.props.selected.filter(shop => {
			if (shop.cats.indexOf(cat_id) !== -1) return true;
			else return false;
		}).sort((a,b) => {
			if(a.title < b.title) { return -1; }
			if(a.title > b.title) { return 1; }
			return 0;
		});
	}
	
	render() {
		return (
			 <div class="chosen-shop-form" ref={this.myScrollList}>
				<div class="chosen-shop-form_box">
					<ul class="chosen-shop-form_list">
						{this.getCategories().map(cat => {
							return (
								<li class="chosen-shop-form_item" key={cat.id}>
									<strong class="chosen-shop-form_title">{cat.title}</strong>
									<ul class="chosen-shop-form_shops">
										{this.getShops(cat.id).map(shop => {
											return (
												<li class="chosen-shop-form_shop" key={shop.id}>
													{shop.title}
													<a class="ico-delete" onClick={e => this.props.changeSelect(e,shop)} href="" data-del="true">Удалить</a>
												</li>
											);
										})}
									</ul>
								</li>
							);
						})}
					</ul>
				</div>
				<div class="buttons-row">
					<button class="btn white" onClick={e => this.props.changeStep('select')}>Ничего не забыли? Вернуться к выбору</button>
					<button class="btn btn-arrow" onClick={e => this.props.changeStep('form')}>Все готово. Отправить заявку!</button>
				</div>
			</div>
		);
	}

}